export default __webpack_public_path__ + "static/media/services_truck_wash.93ea4f12.svg";